export interface ITripRequest {
  orderIds?: number[];
  driverId?: number;
  status?: number;
  reason?: string;
}

export interface IAddOrderToTripRequest {
  orderId: number;
}

export interface IRemoveOrderFromTripRequest {
  orderId: number;
  reason: string;
}

export interface ICancelTripRequest {
  reason?: string;
}

export interface IForceChangeStatusRequest {
  status: number;
  reason: string;
}

export interface IExportTripExcel {
  trip_id: boolean;
  trip_number: boolean;
  driver_id: boolean;
  driver_classification_id: boolean;
  calculating_delivery_cost_per_kilometer: boolean;
  delivery_cost_per_kilometer: boolean;
  extra_order_fixed_bonus_amount: boolean;
  extra_order_fixed_bonus_enabled: boolean;
  order_delivery_cost: boolean;
  store_id: boolean;
  status: boolean;
  orders_count: boolean;
  total_distance: boolean;
  base_cost: boolean;
  bonus_cost: boolean;
  total_cost: boolean;
  started_at: boolean;
  completed_at: boolean;
  cancelled_at: boolean;
  cancellation_reason: boolean;
  created_at: boolean;
}

export const columnsExportTripExcel = [
  "trip_id",
  "trip_number",
  "driver_id",
  "driver_classification_id",
  "calculating_delivery_cost_per_kilometer",
  "delivery_cost_per_kilometer",
  "extra_order_fixed_bonus_amount",
  "extra_order_fixed_bonus_enabled",
  "order_delivery_cost",
  "store_id",
  "status",
  "orders_count",
  "total_distance",
  "base_cost",
  "bonus_cost",
  "total_cost",
  "started_at",
  "completed_at",
  "cancelled_at",
  "cancellation_reason",
  "created_at",
];
